import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LeftImage } from '../Assets/ComplianceWoman.svg';
import { Icon } from './../Components/UI/Icon'
import useGet from '../Hooks/useGet';
import API_ENDPOINTS from '../Config/api';
import DescriptionBanner from '../Components/DescriptionBanner';
import ClipLoader from 'react-spinners/ClipLoader';
import Europe from '../Assets/Europe.svg'
import ModalWrapper from '../Components/UI/ModalWrapper';
import NIS2SummaryContent from '../Components/Modal/NIS2SummaryContent';
import NisCertificateModal from '../Components/Modal/NisCertificateModal';
import Report from '../Pages/Report'
import Timeline from '../Components/Modal/Timeline';
import { useTranslation } from 'react-i18next';


export default function Compliance() {

  const { t, i18n } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [childrenModal, setChildrenModal] = useState(null)
  const [isReportView, setIsReportView] = useState(false)

  const { fetchedData: currentQuestionario, loading: loadingQuestionario } = useGet(API_ENDPOINTS.questionarioCurrent);
  const { fetchedData: aziendaInfo, loading: loadingAzienda } = useGet(API_ENDPOINTS.aziendaInfo);

  // Log per debug
  React.useEffect(() => {
  }, [aziendaInfo, currentQuestionario]);

  // Use Date objects so we can format them according to the active locale
  const inVigoreDate = new Date('2023-01-17')
  const recepitaDate = new Date('2024-10-17')

  // localized date formatter using current i18n language
  const locale = i18n?.language || 'it'
  const dateFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' })
  const inVigore = dateFormatter.format(inVigoreDate)
  const recepita = dateFormatter.format(recepitaDate)

  function handleOpenModal(childrenModal) {
    setChildrenModal(childrenModal)
    setIsModalOpen(true)
  }

  function handleCloseModal() {
    setChildrenModal(null)
    setIsModalOpen(false)
  }


  if (loadingQuestionario || loadingAzienda) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-center">
          <ClipLoader size={50} color="#3466b6" />
          <p className="mt-4 text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  if (!currentQuestionario) {
    return (
      <div className="space-y-6 p-6">
        <DescriptionBanner title={t('Compliance.title')} description={t('DescrBann_Compliance')} />
        <div className="text-center py-12">
          <p className="text-gray-600 text-lg">{t('compliance.noQuestionario', 'Nessun questionario disponibile. Contatta il supporto.')}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {
        !isReportView ?
          <div className="space-y-6 p-6 items-stretch">
            <div>
              <DescriptionBanner title={t('Compliance.title')} description={t('DescrBann_Compliance')} />
            </div>

            <section className="relative bg-gray-100" data-tour="compliance-hero">

              {/* Container principale */}
              <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-stretch">
                {/* Colonna di sinistra: Immagine - nascosta su mobile */}
                <div className="hidden lg:block">
                  <LeftImage />
                </div>

                {/* Colonna di destra */}
                <div
                  className="flex flex-col justify-end w-full"
                  style={{
                    backgroundImage: `url(${Europe})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    // Puoi aggiungere se necessario: minHeight: '100%',
                  }}
                >

                  <div className="flex flex-col h-[70%] mx-3 sm:mx-6 lg:mx-10 gap-3 sm:gap-5 text-white">

                    {/* Piccolo testo in alto (date) */}
                    <p className="text-xs sm:text-sm mb-1 flex flex-col sm:flex-row gap-1 sm:gap-8">
                      <span className="font-semibold">{t('nis2.inForce', { date: inVigore })}</span>
                      <span className="font-semibold text-[#FFDB2E]">{t('nis2.receivedBy', { date: recepita })}</span>
                    </p>

                    {/* Titolo principale */}
                    <h1 className="text-xl sm:text-2xl md:text-5xl w-full lg:w-[90%] mb-4">
                      {t('nis2.directivePrefix')} <span className='font-bold'>{t('nis2.directiveName')}</span>
                    </h1>

                    {/* Testo descrittivo */}
                    <p className=" mb-2">
                      {t('nis2.promptQuestionnaire')}
                    </p>
                    <p className=" mb-6">
                      {t('nis2.reportDescription')}
                    </p>
                  </div>


                  {/* Sezione bottoni */}
                  <div className="flex flex-col justify-end gap-3 sm:gap-4 mb-6 sm:mb-10 mx-2 sm:mx-4 lg:mx-10" data-tour="compliance-buttons">
                    {/* Prima riga - bottoni informativi + certificato */}
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center w-full">
                      <button
                        type="button"
                        className="flex gap-2 h-fit items-center justify-center border border-white text-white px-4 sm:px-5 py-3 rounded hover:bg-white duration-300 hover:text-black transition-colors min-h-[44px] text-sm sm:text-base"
                        onClick={() => handleOpenModal(
                          <div className='mx-4 sm:mx-8 lg:mx-14'>
                            <Timeline />
                          </div>
                        )}
                      >
                        <Icon name={'newspaper'} className="flex-shrink-0" />
                        <span className="whitespace-normal sm:whitespace-nowrap">
                          {t('nis2.viewDeadlines', { defaultValue: i18n.language === 'it' ? 'Visualizza le scadenze NIS2' : 'View NIS2 deadlines' })}
                        </span>
                      </button>

                      <button
                        type="button"
                        className="flex gap-2 h-fit items-center justify-center border px-4 sm:px-5 py-3 border-white text-white rounded hover:bg-white duration-300 hover:text-black transition-colors min-h-[44px] text-sm sm:text-base"
                        onClick={() => handleOpenModal(<NIS2SummaryContent />)}
                      >
                        <Icon name={'newspaper'} className="flex-shrink-0" />
                        <span className="whitespace-normal sm:whitespace-nowrap">
                          {t('nis2.readOriginal', { defaultValue: i18n.language === 'it' ? 'Leggi il testo originale della legge' : 'Read original law text' })}
                        </span>
                      </button>

                      {/* Certificate Button - Mostra SOLO se NIS2 al 100% */}
                      {currentQuestionario?.nis2_completo && (
                        <button
                          type="button"
                          className="flex gap-2 h-fit items-center justify-center border px-4 sm:px-5 py-3 border-white text-white rounded hover:bg-white duration-300 hover:text-black transition-colors min-h-[44px] text-sm sm:text-base"
                          onClick={() => {
                            // Prova diversi campi per l'ID azienda
                            const companyId = aziendaInfo?.id_azienda || aziendaInfo?.id || currentQuestionario?.azienda;
                            
                            if (!companyId) {
                              alert('Errore: ID azienda non disponibile. Controlla la console per dettagli.');
                              console.error('aziendaInfo:', aziendaInfo);
                              console.error('currentQuestionario:', currentQuestionario);
                              return;
                            }
                            handleOpenModal(
                              <NisCertificateModal 
                                companyId={companyId} 
                                onClose={handleCloseModal}
                              />
                            );
                          }}
                        >
                          <Icon name={'certificate'} className="flex-shrink-0" />
                          <span className="whitespace-normal sm:whitespace-nowrap">
                            {t('nis2.printCertificate', 'Stampa Auto-Attestazione')}
                          </span>
                        </button>
                      )}
                    </div>

                    {/* Seconda riga - bottoni azione */}
                    {currentQuestionario?.stato?.toLowerCase() === "completato" ? (
                      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center w-full">
                        <Link
                          to={`/questionario/${currentQuestionario?.id}/review`}
                          type="button"
                          className="flex gap-2 h-fit items-center justify-center bg-yellow-400 px-4 sm:px-5 py-3 text-black font-semibold rounded duration-300 hover:bg-yellow-500 transition-colors min-h-[44px] text-sm sm:text-base"
                        >
                          <Icon name={'edit'} className="flex-shrink-0" />
                          <span className="whitespace-nowrap">{t('nis2.editQuestionnaire', 'Modifica Questionario')}</span>
                        </Link>
                        <Link
                          to={`/questionario/${currentQuestionario?.id}/view`}
                          type="button"
                          className="flex gap-2 h-fit items-center justify-center bg-yellow-400 px-4 sm:px-5 py-3 text-black font-semibold rounded duration-300 hover:bg-yellow-500 transition-colors min-h-[44px] text-sm sm:text-base"
                        >
                          <Icon name={'eye'} className="flex-shrink-0" />
                          <span className="whitespace-nowrap">{t('nis2.viewQuestionnaire', 'Visualizza Questionario')}</span>
                        </Link>
                        <Link
                          onClick={() => setIsReportView(true)}
                          type="button"
                          className="flex gap-2 h-fit items-center justify-center bg-yellow-400 px-4 sm:px-5 py-3 text-black font-semibold rounded duration-300 hover:bg-yellow-500 transition-colors min-h-[44px] text-sm sm:text-base"
                        >
                          <Icon name={'listcheck'} className="flex-shrink-0" />
                          <span className="whitespace-nowrap">{t('nis2.viewReport')}</span>
                        </Link>
                      </div>
                    ) : (
                      <div className="flex gap-2 sm:gap-4 justify-center w-full">
                        <Link
                          to={(aziendaInfo?.id_settore && aziendaInfo?.numero_dipendenti && aziendaInfo?.fatturato_annuo) ? `/questionario/${currentQuestionario?.id}` : `/companyForm/${currentQuestionario?.id}`}
                          type="button"
                          className="flex h-fit gap-2 items-center justify-center bg-yellow-400 px-4 sm:px-5 py-3 text-black font-semibold rounded duration-300 hover:bg-yellow-500 transition-colors min-h-[44px] text-sm sm:text-base"
                        >
                          <Icon name={'listcheck'} className="flex-shrink-0" />
                          <span className="whitespace-normal sm:whitespace-nowrap text-center">
                            {Object.keys(currentQuestionario?.punteggi_sezioni ?? {})?.length === 0 ? t('nis2.startQuestionnaire') : t('nis2.continueQuestionnaire')}
                          </span>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
          :
          currentQuestionario?.id ? <Report id={currentQuestionario.id} /> : null
      }

            <ModalWrapper
                position='center'
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                children={childrenModal}
            />
    </div>
  );
};




